import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
// Inter staat in de applicatie zelf; geen verzoek naar een lettertype-CDN.
import '@fontsource-variable/inter';
import './customCSS/tokens.css';
import './customCSS/components.css';
import './customCSS/schermen.css';
import './customCSS/Custom.css';
import './customCSS/print.css';
import App from './App';
import { pasOrganisatieHuisstijlToe } from './modules/huisstijl';
import { stuurOrganisatieMee } from './modules/organisatieKeuze';

// De gekozen organisatie meesturen met elke API-aanroep (moet vóór de eerste aanroep).
stuurOrganisatieMee();

// Titel, favicon en kleuren volgen de organisatie van het subdomein.
pasOrganisatieHuisstijlToe();

const baseUrl = document.querySelector('base')?.getAttribute('href') ?? '/';

createRoot(document.getElementById('root')).render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>
);
